import { render, staticRenderFns } from "./recognize.vue?vue&type=template&id=2c0a9646&scoped=true&"
import script from "./recognize.vue?vue&type=script&lang=js&"
export * from "./recognize.vue?vue&type=script&lang=js&"
import style0 from "./recognize.vue?vue&type=style&index=0&id=2c0a9646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a9646",
  null
  
)

export default component.exports